import {format} from 'date-fns';
import {CALENDAR_LOCALE_CODES, LOCALE_CODES} from '../i18n/constants';

export function transformDateToYearDayMonthFormat(
  dateString: string,
  separator = '-'
): string {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}${separator}${day}${separator}${month}`;
}

export function transformDateToTime(dateString: string): string {
  const date = new Date(dateString);

  return format(date, 'hh:mm');
}

export function formatDateToDayMonthYearFormat(
  dateString: string,
  separator = '.'
): string {
  const date = new Date(dateString);
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}${separator}${month}${separator}${year}`;
}

export const formatDateBasedOnLocale = (
  date: string,
  locale: LOCALE_CODES,
  withYear = true
) => {
  const d = new Date(date);

  return d.toLocaleDateString(
    locale ? CALENDAR_LOCALE_CODES[locale].code : 'en-US',
    {
      day: 'numeric',
      month: 'long',
      ...(withYear && {year: 'numeric'})
    }
  );
};
